import {
  AcademicCapIcon,
  AnnotationIcon,
  ChatAlt2Icon,
  CheckCircleIcon,
  ClipboardListIcon,
  CreditCardIcon,
  DocumentTextIcon,
  ExclamationIcon,
  InformationCircleIcon,
  PhoneIncomingIcon,
  TagIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import PointIcon from "../Components/PointIcon";

const FixedPointIcon = ({ className }) => (
  <PointIcon iconSize="w-3 h-3" containerSize="w-5 h-5" className={className} />
);

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const notificationType = {
  ebillingreview: {
    title: "E-Billing",
    icon: DocumentTextIcon,
    color: "text-indigo-500",
    path: "/ebilling",
  },
  ebilling: {
    title: "E-Billing",
    icon: DocumentTextIcon,
    color: "text-indigo-500",
    path: "/ebilling",
  },
  transactioninfo: {
    title: "Transaction",
    icon: CreditCardIcon,
    color: "text-teal-500",
    path: "/transaction",
  },
  transaction: {
    title: "Transaction",
    icon: CreditCardIcon,
    color: "text-teal-500",
    path: "/transaction",
  },
  consultation: {
    title: "Consultation",
    icon: ChatAlt2Icon,
    color: "text-blue-500",
    path: "/consultation",
  },
  message: {
    title: "Consultation",
    icon: ChatAlt2Icon,
    color: "text-blue-500",
    path: "/consultation",
  },
  chat: {
    title: "Consultation",
    icon: ChatAlt2Icon,
    color: "text-blue-500",
    path: "/consultation",
  },
  forum: {
    title: "Forum",
    icon: AnnotationIcon,
    color: "text-orange-500",
    path: "/forum",
  },
  subscription: {
    title: "Subscription",
    icon: TagIcon,
    color: "text-yellow-500",
    path: "/subscription",
  },
  emeteraistamping: {
    title: "E-Meterai",
    icon: DocumentTextIcon,
    color: "text-orange-500",
    path: "/emeterai/history",
  },
  tutoring: {
    title: "Tutoring Program",
    icon: AcademicCapIcon,
    color: "text-orange-500",
    path: "/tutoring/detail",
  },
  webinar: {
    title: "Webinar",
    icon: AcademicCapIcon,
    color: "text-orange-500",
    path: "/webinar",
  },
  pointtransaction: {
    title: "pointTransaction",
    icon: FixedPointIcon,
    path: "/point",
  },
  businessserviceorder: {
    title: "businessServiceOrder",
    icon: ClipboardListIcon,
    color: "text-amber-400",
    path: "/business-service/order",
  },
  business_lifecycle: {
    title: "Business",
    icon: ExclamationIcon,
    color: "text-orange-500",
    path: "/business",
  },
};

export function getTypeColor(type = "warning") {
  switch (type) {
    case "info":
      return "blue";
    case "danger":
      return "red";
    case "call":
      return "green";
    case "warning":
      return "amber";
    default:
      return "yellow";
  }
}

export function getTypeIcon(type = "warning") {
  switch (type) {
    case "info":
      return InformationCircleIcon;
    case "danger":
    case "error":
      return XCircleIcon;
    case "message":
      return ChatAlt2Icon;
    case "call":
      return PhoneIncomingIcon;
    case "success":
      return CheckCircleIcon;
    default:
      return ExclamationIcon;
  }
}
